import { defineComponent as _defineComponent } from 'vue'
import { PropType } from 'vue'
	import Category from '@/store/Models/Category'
	import { useModelValue } from '@/composables/useSyncProp'

	type CategoryItem = ReturnType<(typeof Category)['fields']>

	
export default /*#__PURE__*/_defineComponent({
  __name: 'SubCategoriesList',
  props: {
		value: { type: [Object, null] as PropType<CategoryItem | null> },
		list: { type: Array as PropType<CategoryItem[]>, required: true }
	},
  emits: ['input'],
  setup(__props, { emit }) {

const props = __props

	

	

	const selectedItem = useModelValue(props, emit)

	const isItemSelected = (item: CategoryItem) => item.id === selectedItem.value?.id

	const onItemClick = (item: CategoryItem) => {
		if (item.id !== selectedItem.value?.id) {
			selectedItem.value = item
		} else {
			selectedItem.value = null
		}
	}

return { __sfc: true,props, emit, selectedItem, isItemSelected, onItemClick }
}

})